$('.professional-card .card-title').on( "click", function() {
  if ($(this).hasClass('expanded')) {
    $(this).removeClass('expanded');
    $(this).siblings('.card-content').slideUp();
    return;
  }
  //Closes all the open cards
  $('.professional-card .card-content').slideUp();
  $('.professional-card .card-title').removeClass('expanded');

  //Opens the current card
  $(this).addClass('expanded');
  $(this).siblings('.card-content').slideDown();
});

$('.professionals-list-header').on( "click", function() {
  if ($(this).hasClass('expanded')) {
    $(this).removeClass('expanded');
    $(this).siblings('.professionals-list').slideUp();
    return;
  }
  
  //Opens the current card
  $(this).addClass('expanded');
  $(this).siblings('.professionals-list').slideDown();
});